import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Modal } from "antd";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES, VALUE_TYPE } from "constants";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import CompanyLosService from "./../services/company-los-services";

const getFormFields = ({
    allFieldsDisabled
}) => new OrderedMap({
    "is_primary": {
        label: "Is Primary",
        dataIndex: "is_primary",
        key: "is_primary",
        type: INPUT_TYPES.RADIO,
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        // disabled: allFieldsDisabled,

        // onCell: record => ({
        //     record,
        //     key: "is_primary",
        //     dataIndex: "is_primary",
        //     label: "Is Primary",
        //     field: {
        //     }
        // })
    },
    id: {
        key: "id",
        label: "Id",
        dataIndex: "id",
        width: 0,
        type: INPUT_TYPES.NUMBER,
        className: "form-field d-none",
        disabled: true,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     key: "id",
        //     dataIndex: "id",
        //     label: "Id",
        //     field: {
        //     }
        // })
    },
    channel_product: {
        key: "channel_product",
        label: "Channel Product",
        dataIndex: "channel_product",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field",
        disabled: allFieldsDisabled,
        labelProp: "name",
        showSearch: true
        // onCell: record => ({
        //     record,
        //     key: "channel_product",
        //     label: "Channel Product",
        //     dataIndex: "channel_product",
        //     field: {
        //     }
        // })
    },
    name: {
        key: "name",
        label: "Name",
        dataIndex: "name",
        type: INPUT_TYPES.TEXT,
        className: "form-field",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     label: "Name",
        //     dataIndex: "name",
        //     field: {
        //     }
        // })
    },
    value_type: {
        key: "value_type",
        label: "Value Type",
        dataIndex: "value_type",
        type: INPUT_TYPES.SELECT,
        options: VALUE_TYPE.map((v, k) => ({
            label: k,
            value: v
        })).toList(),
        className: "form-field",
        disabled: allFieldsDisabled
        // onCell: record => ({
        //     record,
        //     label: "Value Type",
        //     dataIndex: "value_type",
        //     field: {
        //     }
        // })
    },
    amount: {
        key: "amount",
        label: "Amount",
        dataIndex: "amount",
        type: INPUT_TYPES.TEXT,
        className: "form-field",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     key: "amount",
        //     label: "Amount",
        //     dataIndex: "amount",
        //     field: {
        //     }
        // })
    },
    percentage: {
        key: "percentage",
        label: "Percentage",
        dataIndex: "percentage",
        type: INPUT_TYPES.TEXT,
        className: "form-field",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     key: "percentage",
        //     label: "Percentage",
        //     dataIndex: "percentage",
        //     field: {
        //     }
        // })
    },
    subvention_perc: {
        key: "subvention_perc",
        label: "Subvention Percentage",
        dataIndex: "subvention_perc",
        type: INPUT_TYPES.TEXT,
        className: "form-field",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     key: "subvention_perc",
        //     label: "Subvention Percentage",
        //     dataIndex: "subvention_perc",
        //     field: {
        //     }
        // })
    },
    subvention_days: {
        key: "subvention_days",
        label: "Subvention Days",
        dataIndex: "subvention_days",
        type: INPUT_TYPES.NUMBER,
        className: "form-field",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     key: "subvention_days",
        //     label: "Subvention Days",
        //     dataIndex: "subvention_days",
        //     field: {
        //     }
        // })
    }
});


class CompanyBrandsForm extends React.Component {
    state = {
        brandIds: new Map({}),
        removedBrands: [],
        addedBrands: false
    };

    componentDidMount() {
        // if(!this.state.brandIds.size) {
        //     this.toggleFormGrid("ADD");
        // }
    }

    componentDidUpdate() {
        // if(this.props.values && this.props.values.length && !this.state.addedBrands) {
        //     const values = new List(this.props.values)
        //         .toMap()
        //         .mapEntries(([, v]) => [v.id, v]);
        //     this.setState({
        //         brandIds: values.map((_, k) => {
        //             return {
        //                 ..._,
        //                 key: k,
        //                 index: k
        //             };
        //         }),
        //         addedBrands: true
        //     });
        // }
    }

    // toggleFormGrid = (action = "ADD", id) => {
    //     const { brandIds } = this.state;
    //     let removedBrands = this.state.removedBrands;
    //     const newID = shortID();
    //     switch (action) {
    //     case "ADD":
    //         this.setState({
    //             brandIds: brandIds.set(newID, {...new CompanyBrand().toJS(), key: newID, index: newID})
    //         });
    //         break;
    //     case "REMOVE": {
    //         removedBrands.push(id);
    //         this.setState({
    //             removedBrands: removedBrands
    //         });
    //         break;
    //     }
    //     default:
    //     }
    // };

    formFields = getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    const newValues = values;
                    newValues.amount =  newValues.amount !== "" ? newValues.amount : null;
                    newValues.percentage =  newValues.percentage !== "" ? newValues.percentage : null;
                    newValues.subvention_perc =  newValues.subvention_perc !== "" ? newValues.subvention_perc : null;
                    newValues.subvention_days =  newValues.subvention_days !== "" ? newValues.subvention_days : null;
                    newValues.channel_product =  newValues.channel_product && newValues.channel_product.id;
                    this.props.onValuesSubmit(newValues);
                }
            });
        }
    }

    onSearchProducts = (val) => {
        return CompanyLosService.getChannelProducts(val).then(({data}) => {
            return {
                data
            };
        });
    }

    // checkPrimaryProduct = (record, val) => {
    //     this.setState({
    //         brandIds: this.state.brandIds.set(record.key, {
    //             ...this.state.brandIds.get(record.key),
    //             is_primary: val.target.checked
    //         })
    //     });
    // }

    // tableFormCell = () => props => {
    //     const { dataIndex, record, field, ...restProps } = props;
    //     if(dataIndex === "is_primary") {
    //         field.onChange = this.checkPrimaryProduct.bind(null, record);
    //         field.checked = record.is_primary;
    //     }
    //     if(dataIndex === "channel_product") {
    //         field.onSearch = this.onSearchProducts;
    //     }
    //     const index = record && record.index;
    //     if([INPUT_TYPES.TEXT, INPUT_TYPES.NUMBER, INPUT_TYPES.FLOAT].includes(field.type)) {
    //         if(field.type === INPUT_TYPES.TEXT) {
    //             return (
    //                 <td {...restProps}>
    //                     <Form.Item>
    //                         <Input />
    //                     </Form.Item>
    //                 </td>
    //             );
    //         }
    //         if(field.type === INPUT_TYPES.NUMBER) {
    //             return (
    //                 <td {...restProps}>
    //                     <Form.Item>
    //                         <InputNumber />
    //                     </Form.Item>
    //                 </td>
    //             );
    //         }
    //         if(field.type === INPUT_TYPES.FLOAT) {
    //             return (
    //                 <td {...restProps}>
    //                     <Form.Item>
    //                         <InputNumber step={0.01} />
    //                     </Form.Item>
    //                 </td>
    //             );
    //         }
    //     }
    //     return (
    //         <td {...restProps}>
    //             {this.fieldGenerator(
    //                 `[${index}].${dataIndex}`,
    //                 { ...field, defaultValue: record[dataIndex] },
    //                 this.getValidateStatus(dataIndex)
    //             )()}
    //         </td>);
    // }
    // tableCell = this.tableFormCell(this.props.form);

    onChangeVal = (e) => {
        this.props.form.setFieldsValue({
            is_primary: e.target.value 
        });
    }

    render() {
        // const body = { 
        //     body: { cell: this.tableCell, row: props => <tr {...props} /> } 
        // };
        return (
            <Modal
                width={800}
                bodyStyle={{
                    paddingRight: "3rem",
                    paddingLeft: "3rem"
                }}
                footer={null}
                title="Add/Update Company Brands"
                visible={this.props.visible}
                onCancel={this.props.toggleBrandModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    <div className={"form-row align-items-center"}>
                        {this.formFields.map((field, fieldName) => {
                            if(fieldName === "is_primary") {
                                field.onChange = this.onChangeVal;
                            }
                            if(fieldName === "channel_product") {
                                field.onSearch = this.onSearchProducts;
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button type={"primary"} htmlType={"submit"}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </Form>
            </Modal>
        // <Form onSubmit={this.onValuesSubmit}>
        //     <div className={"form-row align-items-center mb-10"}>
        //         <Table
        //             style={{
        //                 width: "100%"
        //             }}
        //             components={
        //                 body
        //             }
        //             className={"table-padding"}
        //             key={"id"}
        //             dataSource={
        //                 this.state.brandIds.toList().toArray()
        //             }
        //             columns={this.formFields.toList().toArray()}
        //             footer={null}
        //             pagination={false}
        //             scroll={{
        //                 x: true
        //             }}
        //         />
        //     </div>
        //     <div className={"form-row flex-row-reverse p-10"}>
        //         <Button type={"primary"} htmlType={"submit"}>
        //             {this.props.loading ? <Icon type={"loading"} /> : null}
        //             Update
        //         </Button>
        //         <Button className={"mr-5"} onClick={this.toggleFormGrid.bind(null, "ADD")}>
        //             <Icon type={"plus"} />
        //             Add New
        //         </Button>
        //     </div>
        // </Form>
        );
    }
}

CompanyBrandsForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.bool,
    toggleBrandModal: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
                    values
                        .toSeq()
                        .toMap()
                        .map((value) => {
                            let message = null;
                            if (value === null) {
                                message = "Field cannot be empty";
                            }
                            if (message) {
                                return Form.createFormField({
                                    value,
                                    errors: [{ message }]
                                });
                            } else {
                                return Form.createFormField({
                                    value
                                });
                            }
                        }).toJS();
    }
})(CompanyBrandsForm);